var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "address-comparison" }, [
    _c(
      "div",
      { staticClass: "comparison-heading" },
      [
        _c("strong", [_vm._v(_vm._s(_vm.$t("orderLogAddress.comparison")))]),
        _c(
          "el-tag",
          {
            attrs: { type: _vm.tagType(_vm.record.receiveAddressCheckResult) },
          },
          [_vm._v(_vm._s(_vm.resultLabel))]
        ),
      ],
      1
    ),
    _c("div", { staticClass: "addresses" }, [
      _c("div", { staticClass: "address" }, [
        _c("h3", [_vm._v(_vm._s(_vm.$t("orderLogAddress.before")))]),
        _c("p", [
          _c("span", [
            _vm._v(_vm._s(_vm.$t("collectionCenter.receivingState"))),
          ]),
          _c("b", [_vm._v(_vm._s(_vm.record.originalReceiveState || "—"))]),
        ]),
        _c("p", [
          _c("span", [
            _vm._v(_vm._s(_vm.$t("collectionCenter.receivingCity"))),
          ]),
          _c("b", [_vm._v(_vm._s(_vm.record.originalReceiveCity || "—"))]),
        ]),
      ]),
      _c("i", {
        staticClass: "el-icon-right",
        attrs: { "aria-hidden": "true" },
      }),
      _c(
        "div",
        { staticClass: "address", class: { after: _vm.hasCheckedAddress } },
        [
          _c("h3", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  _vm.hasCheckedAddress
                    ? "orderLogAddress.after"
                    : "orderLogAddress.loggedAddress"
                )
              )
            ),
          ]),
          _c("p", [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("collectionCenter.receivingState"))),
            ]),
            _c("b", { class: { changed: _vm.stateChanged } }, [
              _vm._v(_vm._s(_vm.record.receiveState || "—")),
            ]),
          ]),
          _c("p", [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("collectionCenter.receivingCity"))),
            ]),
            _c("b", { class: { changed: _vm.cityChanged } }, [
              _vm._v(_vm._s(_vm.record.receiveCity || "—")),
            ]),
          ]),
        ]
      ),
    ]),
    _c("p", { staticClass: "comparison-note" }, [
      _vm._v(_vm._s(_vm.$t(_vm.noteKey))),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }